export const environment = {
  production: true,
  //apiUrl: 'http://localhost:5268',
  apiUrl: 'https://cde-oxy.g-talent.cl/api',
  clientPath: '/client',
  containerOwnerPath: '/containerOwner',
  containerPath: '/container',
  containerTypePath: '/typeContainer',
  maintenanceTypePath: '/maintenanceType',
  taskPath: '/task',
  acceptanceCriteriaPath: '/acceptanceCriteria',
  maintenancePath: '/maintenance',
  viewTypePath: '/viewType',
  statePath: '/state',
  disabledPath: '/disabled',
  rolePath: '/role',
  reportPath: '/report',
  optionPath: '/option',
  elementPath: '/element',
  dashboardPath: '/dashboard',
  maintenanceRecordPath: '/maintenanceRecord',
  timelinePath: '/timeline',
  visation: '/visation',
  visationAction: '/visationaction',
  update: '/update',
  updateRecord: '/updateRecord',
  shiftClosure: '/shiftclosure',
  updateValue: '/updateValue',
  user:'/user',
  updateArea: '/updateArea',
  userFilter: '/userFilter',
  oidc: {
     authority: 'https://cognito-idp.us-east-2.amazonaws.com/us-east-2_tR7OqbyUq',
     clientId: '6v8d00e1a6bdgeku20h0n3fv6v',
    //  redirectUri: 'http://localhost:4200/auth-callback',
    //  postLogoutRedirectUri: 'http://localhost:4200/logout-callback',
     redirectUri: 'https://cde-oxy.g-talent.cl/auth-callback',
     postLogoutRedirectUri: 'https://cde-oxy.g-talent.cl/logout-callback',
     scope: 'openid profile email',
     responseType: 'code',
     silentRenew: false,
     useRefreshToken: true,
     cognitoDomain: 'us-east-2tr7oqbyuq.auth.us-east-2.amazoncognito.com',
   },
  useDummyLogin: false,
};